(function() {
    angular
        .module("wzModule")
        .controller("WzHistoryController", WzHistoryController)

    WzHistoryController.$inject = [
        "$rootScope",
        "$scope",
        "$stateParams",
        "prefs",
        "userMessagingService",
        "wzService",
        "$filter",
        "$uibModal"
    ]

    function WzHistoryController(
        $rootScope,
        $scope,
        $stateParams,
        prefs,
        userMessagingService,
        wzService,
        $filter,
        $uibModal
    ){
        "use strict"

        // $rootScope.title   = "Work Zone History | WANCO"
        $rootScope.page    = 1
        $rootScope.perPage = prefs.get().wz.history.perPage
        $rootScope.exportEndDate = new Date()

        $scope.startDate = ""
        $scope.endDate   = new Date()
        $scope.actions   = []
        $scope.hasSetExportEndDate = false

        const getPageCount = () => {
            $rootScope.maxPages = Math.ceil($rootScope.max / $rootScope.perPage)
        }

        const applyActions = (actions) => {

            if (actions) {

                for (const action of actions) {

                    if ($scope.wz.hasOwnProperty("timezone_iana")) {

                        // Format Date/Times

                        action.started_display = moment(action.started_time).tz($scope.wz.timezone_iana).format("YYYY-MM-DD @ HH:mm:ss z")

                        if (action.completed_time) {
                            action.completed_display = moment(action.completed_time).tz($scope.wz.timezone_iana).format("HH:mm:ss")
                        }

                        for (const telemetry of action.telemetries) {
                            telemetry.report_time_display = moment(telemetry.report_time).tz($scope.wz.timezone_iana).format("HH:mm:ss")
                        }

                        if (!$scope.hasSetExportEndDate) {
                            $rootScope.exportEndDate = moment(action.started).tz($scope.wz.timezone_iana).toDate()
                            $scope.hasSetExportEndDate = true
                        }
                    }

                    // Sort QWS Sensors

                    action.telemetries.sort((a, b) => {
                        return a.upstream_proximity < b.upstream_proximity ? -1 : 1
                    })

                    // Message Renders

                    action.messageRender = {
                        currentPage: 1,
                        pageCount:   action.intended_message_strings.length
                    }
                }

                $scope.actions = actions

                getPageCount()

            }
        }

        const getActions = () => {

            const success = (data, total) => {
                applyActions(data)
                $rootScope.max = total
            }

            const failure = (error) => {
                userMessagingService.error(error)
            }

            wzService.listActions($stateParams.wz_id, $filter("date")($scope.startDate, "yyyy-MM-dd") || "", $filter("date")($scope.endDate, "yyyy-MM-dd") || "", $rootScope.page, $rootScope.perPage, success, failure)

        }

        $scope.changePerPage = (perPage) => {
            $rootScope.perPage = perPage
            $rootScope.page = 1
            getActions()
            prefs.set(prefs.selectors().wz.history.perPage, perPage)
        }

        $scope.changePage = (page) => {

            const newPage = $rootScope.page + page

            if (newPage < 1 || newPage > $rootScope.maxPages) {
                return
            }

            $rootScope.page = newPage
            getActions()

        }

        $scope.changeStartDate = (date) => {
            $scope.startDate = date
        }

        $scope.changeEndDate = (date) => {
            $scope.endDate = date
        }

        $scope.getAllActions = (startDate, endDate) => {

            $rootScope.page = 1

            $scope.changeStartDate(startDate)
            $scope.changeEndDate(endDate)
            $rootScope.minDate = startDate
            $rootScope.maxDate = endDate
            $scope.minDateOptions.maxDate = endDate
            $scope.maxDateOptions.minDate = startDate

            getActions()

        }

        $scope.messageRenderGotoPage = (action, page) => {
            action.messageRender.currentPage = page
        }

        $scope.shadeBackground = (index, isOddItem) => {
            // 4 items per row
            const isOddRow = Math.floor(index / 4) % 2 === 0
            return (isOddRow && !isOddItem) || (!isOddRow && isOddItem)
        }

        $scope.minStatus = {
            opened: false
        }
        $scope.maxStatus = {
            opened: false
        }

        $scope.today = () => {
            $scope.dt = new Date()
        }
        $scope.today()

        $scope.dtMin = $rootScope.minDate
        $scope.dtMax = $rootScope.maxDate || new Date()

        $scope.clear = () => {
            $scope.dt = null
        }

        $scope.openMin = () => {
            $scope.minStatus.opened = true
        }

        $scope.openMax = () => {
            $scope.maxStatus.opened = true
        }

        $scope.minDateOptions = {
            formatYear:  "yy",
            startingDay: 1,
            showWeeks:   false,
            maxDate:     $scope.dtMax
        }

        $scope.maxDateOptions = {
            formatYear:  "yy",
            startingDay: 1,
            showWeeks:   false,
            minDate:     $scope.dtMin
        }

        $scope.format = "MM/dd/yyyy"

        $scope.allowExport = true

        $scope.openExportModal = () => {

            $scope.allowExport = false

            const success = () => {
                $scope.allowExport = true
            }

            const failure = (error) => {
                $scope.allowExport = true
                userMessagingService.error("Failed to export Work Zone Actions: " + error)
            }

            $uibModal.open({
                templateUrl: "app/modals/export-data-modal.view.html",
                controller: "ExportDataModalController",
                resolve: {
                    title: () => {
                        return "Work Zone Actions"
                    },
                    exportFunction: () => {
                        return (endDate) => {
                            wzService.exportActions($scope.wz.id, endDate, success, failure)
                        }
                    }
                }
            }).result.catch((res) => {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.getAllActions($scope.startDate, $scope.endDate)

        $scope.$watch("wz", () => {
            if ($scope.wz && $scope.wz.hasOwnProperty("id")) {

                // if ($rootScope.page === 1 && $scope.wz.qws.last_action.hasOwnProperty("id")) {
                //     if ($scope.actions.length === 0 || ($scope.wz.qws.last_action.id !== $scope.actions[0].id && moment($scope.actions[0].started) - moment($scope.wz.qws.last_action.started) > 600)) {
                //         $scope.actions = [$scope.wz.qws.last_action].concat($scope.actions)
                //     }
                // }

                applyActions($scope.actions)

            }
        })

    }
})()
